import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import Card from '../ui/Card';
import type { SampleChartSpec } from '../../data/projects';

export default function SampleChart({ title, categories, yAxisTitle, series }: SampleChartSpec) {
  const options: Highcharts.Options = {
    chart: { type: 'column', backgroundColor: 'transparent', style: { fontFamily: 'system-ui, -apple-system, sans-serif' } },
    title: { text: undefined },
    credits: { enabled: false },
    xAxis: { categories },
    yAxis: { title: { text: yAxisTitle }, min: 0 },
    legend: { enabled: series.length > 1 },
    series: series.map((item) => ({
      type: 'column' as const,
      name: item.name,
      data: item.data,
      color: item.color,
    })),
  };

  return (
    <Card>
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
        <span className="text-xs font-medium uppercase tracking-wide text-amber-800 bg-amber-50 border border-amber-100 rounded px-2 py-1">
          Sample data
        </span>
      </div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Card>
  );
}
